import { jsx as _jsx } from "react/jsx-runtime";
import { Card, EmptyState, Layout, Page } from "@shopify/polaris";
const NotFound = () => {
    return (_jsx(Page, { children: _jsx(Layout, { children: _jsx(Layout.Section, { fullWidth: true, children: _jsx(Card, { children: _jsx(EmptyState, { heading: "Page Not Found", image: "https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png", children: _jsx("p", { children: "Oops! The page you are looking for might have been removed, had its name changed, or is temporarily unavailable." }) }) }) }) }) }));
};
export default NotFound;
